/**
 * Which `mecIs*` flag a Days After field should carry.
 *
 * MEC and BAD share the base slot and carry no flag. ABS, COE and DBC each set exactly one
 * `mecIs*` on the field's metadata. A field with none of them therefore reads as "base" — right
 * when the form declares MEC or BAD, wrong when it declares only relative types.
 *
 * In that second case the Field Editor's Type dropdown has no base option to fall back on, so it
 * displays the first relative type it offers. The label looks correct and nothing is stored,
 * because the flag is only written by the dropdown's onChange and the analyst never changed it.
 * Every datetime field on a DBC-only form ends up published without `mecIsDbc`.
 *
 * Shared by the Field Editor (writes it on save) and fix-days-after-type.js (backfills forms
 * already published without it), so the two can never disagree about what the type should be.
 *
 * @param {Object} metadata - field.metadata
 * @param {Object} daysAfter - formDetails.settings.daysAfter (internal shape: mec/bad/bs/coe/dbc)
 * @returns {string|null} "mecIsAbs" | "mecIsCoe" | "mecIsDbc", or null when nothing is missing
 */
export function missingDaysAfterTypeFlag(metadata, daysAfter) {
  if (!metadata || metadata.mec === undefined || metadata.mec === null) return null;
  if (metadata.mecIsAbs || metadata.mecIsCoe || metadata.mecIsDbc) return null;

  const da = daysAfter || {};
  // A real base slot exists, so carrying no flag is the correct state.
  if (da.mec || da.bad) return null;

  if (da.bs) return "mecIsAbs";
  if (da.coe) return "mecIsCoe";
  if (da.dbc) return "mecIsDbc";
  return null;
}

/** Label for the flag, for reports. */
export function daysAfterTypeLabel(flag) {
  return flag === "mecIsAbs" ? "ABS" : flag === "mecIsCoe" ? "COE" : flag === "mecIsDbc" ? "DBC" : "";
}
